import { multimediaApiConfig } from '@/constants/ApiUrls';
import requestMethods from '@/helpers/request/requestMethods';

async function getContentSections({ links, isBabiesMode, id = null }) {
    const homePageConfig = {
        ...multimediaApiConfig,
        url: multimediaApiConfig(id).url + (isBabiesMode ? '?age_level=babies' : '')
    };

    const routeConfig = homePageConfig;

    try {
        const resp = await requestMethods.get({
            routeConfig: { ...routeConfig, url: links?.next || routeConfig.url }
        });
        return resp.data;
    } catch (err) {
        console.log('error: ', err);
    }
}

export { getContentSections };
